import { Flex, Text, TextContainer } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

export const GeographyLetDown = ({ eligibilityLink }: { eligibilityLink: ReactNode }) => {
  const intl = useIntl();

  return (
    <Flex direction="column" gap="4">
      <TextContainer>
        {intl.formatMessage(MESSAGES.letDownReasonGeography, { p: (chunks: string) => <Text>{chunks}</Text> })}
      </TextContainer>
      <Text>{eligibilityLink}</Text>
    </Flex>
  );
};
